import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { getCurrentBlock, updateCurrentBlock, updateCurrentData } from './requests'

import { ItemType, type MilestoneModel } from '@aytm/app/insights/dashboard/models/types.ClientDTO'

export type ElementTogglePayload = {
  showSigtest?: boolean
  showChart?: boolean
  showTimeline?: boolean
  showRanks?: boolean
  showImages?: boolean
}

export type ColumnBlinkPayload = {
  uid?: string
  index?: number
}

export type UpdateTimelinePayload = {
  timelineStart?: number
  timelineEnd?: number
}

/**
 * Change component elements visibility
 */
export const elementToggle = (state: InsightsDashboardPoolState, payload: ElementTogglePayload) => {
  let resultState = state
  if ('showSigtest' in payload) {
    resultState = updateCurrentBlock(state, { showSigtest: payload.showSigtest })
  }
  if ('showChart' in payload) {
    resultState = updateCurrentBlock(resultState, { showChart: payload.showChart })
  }
  if ('showTimeline' in payload) {
    resultState = updateCurrentBlock(resultState, { showTimeline: payload.showTimeline })
  }
  if ('showRanks' in payload) {
    resultState = updateCurrentBlock(resultState, { showRanks: Boolean(payload.showRanks) })
  }
  if ('showImages' in payload) {
    resultState = updateCurrentBlock(resultState, { showImages: Boolean(payload.showImages) })
  }
  return resultState
}

/**
 * Start blinking effect for the component with specified uid
 */
export const columnBlink = (state: InsightsDashboardPoolState, payload: ColumnBlinkPayload) => {
  let resultState = state
  if ('uid' in payload) {
    resultState = updateCurrentData(state, { blinkUid: payload?.uid ?? null })
  }
  if ('index' in payload) {
    resultState = updateCurrentData(state, { blinkIndex: payload.index })
  }
  return resultState
}

/**
 * Update timeline range
 */
export const updateTimeline = (state: InsightsDashboardPoolState, payload: UpdateTimelinePayload) => {
  let resultState = state
  if ('timelineStart' in payload && payload.timelineStart) {
    resultState = updateCurrentBlock(state, { timelineStart: payload.timelineStart })
  }
  if ('timelineEnd' in payload && payload.timelineEnd) {
    resultState = updateCurrentBlock(resultState, { timelineEnd: payload.timelineEnd })
  }
  if ('milestones' in payload && payload.milestones) {
    resultState = updateCurrentBlock(resultState, { milestones: payload.milestones as MilestoneModel[] })
  }
  return resultState
}

export const reassignSigtestLetters = (state: InsightsDashboardPoolState) => {
  const block = getCurrentBlock(state)
  const itemsArray = block?.getItemsArray() || []
  const newItems = itemsArray.map(({ letter: _letter, ...item }) => item as ItemType)
  return updateCurrentBlock(state, { letterStore: {}, items: newItems })
}
